import axios from 'axios';
/*
Here we create an instance of axios to use in a general way throughout the application, 
we can specify the baseURL to always add api/ to all the routes that we consult.
*/

export const SUCCESS_RESPONSE = true;
export const ERROR_RESPONSE = false;

export const PUBLIC = axios.create();

export const AMS = axios.create({
  baseURL: process.env.REACT_APP_RAP_AMS_BASE_URL?? `https://qpss.ilo.org:9083/matrix/`
});

export default axios.create({
  baseURL: process.env.REACT_APP_RAP_API_BASE_URL?? `api`
});


/*
Use this routes for AMS
PRD: https://qpss.ilo.org:9083/matrix/
QA: http://20.110.98.111:9083/matrix/
QA_OLD: http://52.247.226.189:8090/matrix/
DEV: http://127.0.0.1:5000/matrix/

#! we use this one because we were unable to use qpss.ilo.org:9083 due to Bad Gateway reasons.
PRD-workaround: http://168.62.51.191:9083/matrix/ 

*/